import {
  FETCH_EXPANSION_INFO,
  FETCH_EXPANSION_INFO_SUCCESS,
  ADD_EXPANSION,
  ADD_EXPANSION_FETCH,
  ADD_EXPANSION_FETCH_ERROR,
  FETCH_EXPANSION_FETCH,
  FETCH_EXPANSION_FETCH_SUCCESS
} from "./types";
import { Dispatch } from "react";
import { auth, database } from "../../App";
import { ExpansionsActionInterface } from "../reducers/ExpansionsReducers";

export const fetchExpansionsInfo = () => {
  return (dispatch: Dispatch<ExpansionsActionInterface>) => {
    const { currentUser } = auth;
    if (currentUser) {
      dispatch({ type: FETCH_EXPANSION_INFO });
      database
        .ref("users")
        .child(currentUser.uid)
        .child("expansions")
        .on("value", snapshot => {
          return dispatch({
            type: FETCH_EXPANSION_INFO_SUCCESS,
            info: snapshot.val()
          });
        });
    } else {
      dispatch({ type: ADD_EXPANSION_FETCH_ERROR });
    }
  };
};

// USE WHEN ADD NEW EXPANSION
// export const addExpansionsImages = (
//   expansionName: string,
//   imageList: string[]
// ) => {
//   return (dispatch: Dispatch<{ type: string; payload?: any }>) => {
//     const dictImages = { count: imageList.length, images: {} as any };
//     imageList.forEach((image, index) => {
//       dictImages.images[index] = image;
//     });
//     database
//       .ref("expansions")
//       .child(expansionName)
//       .set({ ...dictImages });
//   };
// };

export const fetchExpansionsImages = () => {
  return (dispatch: Dispatch<ExpansionsActionInterface>) => {
    const { currentUser } = auth;
    if (currentUser) {
      dispatch({ type: FETCH_EXPANSION_FETCH });
      database.ref("expansions").on("value", snapshot => {
        if (snapshot.val()) {
          return dispatch({
            type: FETCH_EXPANSION_FETCH_SUCCESS,
            expansions: snapshot.val()
          });
        } else {
          return dispatch({
            type: FETCH_EXPANSION_FETCH_SUCCESS
          });
        }
      });
    } else {
      dispatch({ type: ADD_EXPANSION_FETCH_ERROR });
    }
  };
};

export const addExpansion = (expansionName: string) => {
  return (dispatch: Dispatch<{ type: string }>) => {
    dispatch({ type: ADD_EXPANSION });
    const { currentUser } = auth;
    if (currentUser) {
      database
        .ref("users")
        .child(currentUser.uid)
        .child("expansions")
        .update({
          [expansionName]: true
        })
        .then(() => {
          dispatch({ type: ADD_EXPANSION_FETCH });
        });
    } else {
      dispatch({ type: ADD_EXPANSION_FETCH_ERROR });
    }
  };
};
